import { makeAutoObservable } from "mobx";

class StateAnalyticCompany {
  constructor() {
    makeAutoObservable(this);
  }

  id_company = null;

  setParameter = (name, value) => {
    this[`${name}`] = value;
  };
}

export default new StateAnalyticCompany();
